import { render, staticRenderFns } from "./AntiScamForm.vue?vue&type=template&id=7ae76012&scoped=true&"
import script from "./AntiScamForm.vue?vue&type=script&lang=js&"
export * from "./AntiScamForm.vue?vue&type=script&lang=js&"
import style0 from "./AntiScamForm.vue?vue&type=style&index=0&id=7ae76012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae76012",
  null
  
)

export default component.exports